// Types
import { Dispatch } from 'types'

export const actions = {
  toggleStickyHeader: (headerVisible: boolean) => (dispatch: Dispatch) =>
    dispatch({
      type: 'TOGGLE_STICKY_HEADER',
      data: headerVisible,
    }),
}
